import { createContext, useContext, useEffect, useState } from "react";
import api, { apiError } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=logged

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      return;
    }
    // Try session cookie first (Google Auth), then JWT token
    api
      .get("/auth/me", { withCredentials: true })
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("token");
        setUser(false);
      });
  }, []);

  async function login(email, password) {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("token", data.token);
    // Fetch full profile so slug + working_hours + treatments are available immediately
    try {
      const me = await api.get("/auth/me");
      setUser(me.data);
    } catch {
      setUser({ id: data.id, email: data.email, name: data.name, role: data.role, auth_provider: "email" });
    }
    return data;
  }
  async function register(email, password, name, extras = {}) {
    const { data } = await api.post("/auth/register", { email, password, name, ...extras });
    localStorage.setItem("token", data.token);
    try {
      const me = await api.get("/auth/me");
      setUser(me.data);
    } catch {
      setUser({ id: data.id, email: data.email, name: data.name, role: data.role, auth_provider: "email", slug: data.slug });
    }
    return data;
  }
  async function logout() {
    try {
      await api.post("/auth/logout", {}, { withCredentials: true });
    } catch (_) {}
    localStorage.removeItem("token");
    setUser(false);
  }
  return (
    <AuthCtx.Provider value={{ user, setUser, login, register, logout, apiError }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
